const CHEST_PRIZE_TYPE_BASE_OPTIONS = [
	{ value: "wooden", label: "Wooden" },
	{ value: "iron", label: "Iron" },
	{ value: "silver", label: "Silver" },
	{ value: "gold", label: "Gold" },
	{ value: "platinum", label: "Platinum" },
	{ value: "crystal", label: "Crystal" },
	{ value: "mysterious", label: "Mysterious" },
	{ value: "royal", label: "Royal" },
];

export const CHEST_PRIZE_TYPE_OPTIONS = CHEST_PRIZE_TYPE_BASE_OPTIONS.map((option, index) => ({
	...option,
	label: `${option.label} lvl: ${index + 1}`,
}));

export const getChestPrizeTypeLevel = (value) => {
	const index = CHEST_PRIZE_TYPE_OPTIONS.findIndex((option) => option.value === value);
	return index >= 0 ? index + 1 : null;
};

export const formatChestPrizeType = (value) => {
	const option = CHEST_PRIZE_TYPE_OPTIONS.find((item) => item.value === value);

	if (!option) {
		return value || "Unknown";
	}

	return option.label;
};

export const getChestBannerPath = (typeChest) => (typeChest ? `/png/Chests/Banners/${typeChest}.png` : "");

export const getChestBannerUrl = (cdn, typeChest) => {
	return cdn && typeChest ? `${cdn}${getChestBannerPath(typeChest)}` : "";
};
